import { db, timestamp } from '../firebase/core'

const baseMutations = {
  _set(state, data) {
    Object.assign(state, data)
  }
}

const baseActions = {
  $set({ state }, { key, value }) {
    if (state[key] === undefined) return;
    return state.$doc.set({ [key]: value }, { merge: true })
  },
  $update({ state }, data) {
    return state.$doc.set(state.$formatter(data), { merge: true })
  },
  $connect({ state, commit }, ref) {
    if (state.$connection) return
    state.$doc = db.doc(ref)
    state.$connection = state.$doc.onSnapshot(doc => {
      commit('_set', doc.data())
    })
  },
  $disconnect({ state }) {
    if (!state.$connection) return
    state.$connection()
  }
}

const baseGetters = {
  state(state) {
    return state
  }
}

export default function({ $name, $formatter, state, mutations, getters, actions }) {
  return {
    namespaced: true,
    state: Object.assign({
      $name,
      $formatter,
      $doc: null,
      $connection: null,
      $timestamp: timestamp
    }, state),
    mutations: Object.assign({}, baseMutations, mutations),
    getters: Object.assign({}, baseGetters, getters),
    actions: Object.assign({}, baseActions, actions)
  }
}

